import { storage } from '../compat/storage';

export async function fetchMostWatched(userId: string) {
  const stats = await storage.getWatchStats();

  return stats[userId] ?? [];
}
